import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "underlineForm" }
const _hoisted_14 = {
  class: "dialog-footer mt-20",
  style: {"text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_FormDeliver = _resolveComponent("FormDeliver")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.businessNo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.businessName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.businessName) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "材料编号", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.materialNo,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.materialNo) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "材料名称", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.materialName,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.materialName) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "材料型号", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.materialModel,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.materialModel) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "采购状态", -1)),
        _createVNode(_component_el_select, {
          filterable: true,
          modelValue: _ctx.listQuery.purchaseStatus,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.purchaseStatus) = $event)),
          class: "filter-item",
          placeholder: "",
          clearable: "",
          "collapse-tags": "",
          size: _ctx.t('table.btnSize'),
          onChange: _ctx.handleFilter
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseStatusOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "size", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "出库状态", -1)),
        _createVNode(_component_el_select, {
          filterable: true,
          modelValue: _ctx.listQuery.status,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.status) = $event)),
          class: "filter-item",
          placeholder: "",
          clearable: "",
          "collapse-tags": "",
          size: _ctx.t('table.btnSize'),
          onChange: _ctx.handleFilter
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "size", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.listQuery.startTime,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
          type: "date",
          placeholder: " ",
          format: "YYYY-MM-DD",
          "value-format": "YYYY-MM-DD",
          onChange: _ctx.handleFilter,
          size: _ctx.t('table.btnSize')
        }, null, 8, ["modelValue", "onChange", "size"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.listQuery.endTime,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
          type: "date",
          placeholder: " ",
          format: "YYYY-MM-DD",
          "value-format": "YYYY-MM-DD",
          onChange: _ctx.handleFilter,
          size: _ctx.t('table.btnSize')
        }, null, 8, ["modelValue", "onChange", "size"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "filter-item",
          type: "primary",
          size: _ctx.t('table.btnSize'),
          onClick: _ctx.handleFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
          ]),
          _: 1
        }, 8, ["size", "onClick"])), [
          [_directive_waves]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "filter-item",
          size: _ctx.t('table.btnSize'),
          onClick: _ctx.handleReset
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
          ]),
          _: 1
        }, 8, ["size", "onClick"])), [
          [_directive_waves]
        ]),
        _createVNode(_component_el_button, {
          class: "filter-item",
          type: "primary",
          size: _ctx.t('table.btnSize'),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCommand('office-apply')))
        }, {
          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
            _createTextVNode(" 申请办公用品 ", -1)
          ]))]),
          _: 1
        }, 8, ["size"]),
        _createElementVNode("span", {
          class: "svg-icon cursor mr-10 ml-10",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCommand('refresh')))
        }, [...(_cache[29] || (_cache[29] = [
          _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
        ]))]),
        _createElementVNode("span", {
          class: "svg-icon cursor",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('column')))
        }, [...(_cache[30] || (_cache[30] = [
          _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
        ]))]),
        _cache[31] || (_cache[31] = _createStaticVNode("<span class=\"ml-10 filter-mark\"><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:red;\"></span><span class=\"status-text\">待定（无需采购/已入库）</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:blue;\"></span><span class=\"status-text\">待定（需采购且未入库）</span></span></span>", 1))
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_TableList, {
      ref: "tableListRef",
      dataList: _ctx.list,
      total: _ctx.total,
      columnAllData: _ctx.columnAllData,
      tableName: _ctx.TableName,
      page: _ctx.listQuery.page,
      size: _ctx.listQuery.size,
      canRefresh: false,
      canChangeColumn: false,
      showSummary: true,
      tableRowClassName: _ctx.tableRowClassName,
      onCommandChange: _ctx.handleCommand
    }, {
      "operation-action": _withCtx((scope) => [
        ((scope.row.purchaseStatusValue === '无需采购' || scope.row.purchaseStatusValue === '已入库') && scope.row.statusValue === '待定')
          ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              href: "javascript:void(0);",
              class: "mr-10",
              type: "primary",
              onClick: ($event: any) => (_ctx.handleCommand('deliver-comfirm', scope.row))
            }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                _createTextVNode(" 出库 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataList", "total", "columnAllData", "tableName", "page", "size", "tableRowClassName", "onCommandChange"])), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.deliverVisible,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.deliverVisible) = $event)),
      title: "出库",
      width: "70%"
    }, {
      default: _withCtx(() => [
        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
          _createElementVNode("span", { class: "left" }, "物料信息")
        ], -1)),
        _createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "物料编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料型号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.model), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料单位：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.material.materialUnit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "物料类别：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.materialClass), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "数量：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.activeRow.num), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, {
          ref: "dataForm",
          model: _ctx.ruleForm,
          rules: _ctx.rules,
          "label-position": "top",
          "label-width": "100px",
          class: "mb-20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                label: "数量",
                prop: "num"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.ruleForm.num,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.num) = $event)),
                    type: "number",
                    min: 0,
                    max: _ctx.activeRow.num
                  }, null, 8, ["modelValue", "max"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "位置",
                prop: "locationId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    filterable: true,
                    modelValue: _ctx.ruleForm.locationId,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.locationId) = $event)),
                    class: "filter-item",
                    placeholder: "输入关键字搜索",
                    clearable: "",
                    size: _ctx.t('table.btnSize')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.locationId,
                          label: item.location?.location,
                          value: item.locationId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "size"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_button, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deliverVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleDeliverComfirm()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.officeDeliverVisible,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.officeDeliverVisible) = $event)),
      title: "申请办公用品",
      width: "80%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormDeliver, {
          id: null,
          type: "OFFICE",
          "onUpdate:visibel": _cache[17] || (_cache[17] = ($event: any) => (_ctx.officeDeliverVisible = false)),
          onSubmit: _ctx.getList
        }, null, 8, ["onSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}